import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CheckboxField from "../checkBox/CheckboxField";
import InputTextField from "../inputTextField/InputTextField";
import InputNumberField from "../inputNumberField/InputNumberField";
import { inventoryActions, shopifyActions } from "../../../redux/actions";
import {
  getCustomCategoriesOptionList,
  getCustomSubCategoriesOptionList,
  getCustomProductSaleTypeOptionList,
  getCustomTypesOptionList,
  getDefaultShopifySettings,
  getTypeOrCategoryObject,
  handleBeautifyMarketPrice,
  isShopifyConnected,
  handleIsLinkToShopify,
  isSpinnerEnabled,
  parseToThousandSeperatorDecimalNumber,
  handleProductSaleTypeChange,
} from "../../utility";
import InputTextArea from "../inputTextArea/InputTextArea";
import {
  DollarIcon,
  ExpandTabIcon,
  SettingsIcon,
} from "../../../assets/icons/iconsProvider";
import CustomItemProductTypeSelectField from "../../../views/Inventory/Shared/CustomItemProductTypeSelectField";
import CustomItemCategorySelectField from "../../../views/Inventory/Shared/CustomItemCategorySelectField";
import CustomItemSubcategorySelectField from "../../../views/Inventory/Shared/CustomItemSubcategorySelectField";
import CustomItemConditionSelectField from "../../../views/Inventory/Shared/CustomItemConditionSelectField";
import ProductTagList from "../tags/ProductTagList";
import { ReactComponent as ShopifyLogo } from "../../../assets/images/ShopifyLogoGrey.svg";
import Button from "../Buttons/Button";
import {
  buttonNameConstants,
  buttonTypeConstants,
  EMPTY_STRING,
  inventoryConstants,
  SHOPIFY_STATUS_OPTIONS,
} from "../../../constants";
import { connect } from "react-redux";
import ShopifySelectDropdown from "../selectDropdown/ShopifySelectDropdown";
import IconSelectField from "../selectField/IconSelectField";
import SelectField from "../selectField/SelectField";
import {
  PRODUCT_CONDITIONS_ENUMS,
  PRODUCT_TYPES_ENUMS,
} from "../../../system/globalEnums";
import ProductShopifyMappingSettingModal from "./ProductShopifyMappingSettingModal";

const CustomInventoryComponent = ({
  ratio,
  values,
  shopify,
  formikRef,
  productTags,
  currentStore,
  spinnerArray,
  isProductEdit,
  setFieldValue,
  isProductExist,
  handleHideModal,
  isCustomItemTab,
  handleTypeChange,
  itemOrganization,
  isTradeCustomItem,
  setIsCustomItemTab,
  handleCategoryChange,
  handleCashOfferValues,
  handleTradeOfferValues,
  handleSubCategoryChange,
  customProductSelectedTags,
  isEditCustomItemModal = false,
  onCustomProductSelectTagsChange,
  setProductShopifySettings,
  productShopifySettings,
  getShopifyMappingsById,
}) => {
  //-------Reducer
  const { shopifySettings } = shopify;
  const { customTypes, customCategories, customSubCategories } =
    itemOrganization;

  //------- isShopifyConnected
  const isShopifyStoreConnected = isShopifyConnected(currentStore);
  const isShopifyStoreConnectedForProduct = handleIsLinkToShopify(
    currentStore,
    values
  );

  const [shopifyStatus, setShopifyStatus] = useState(SHOPIFY_STATUS_OPTIONS[0]);
  const handleStatusChange = (option) => {
    setShopifyStatus(option);
    setFieldValue("isLinkToShopify", option.value);
  };

  const handleStoreAndOnlineQuantityChange = (value) => {
    setFieldValue("isOnlineQuantity", value);
  };

  useEffect(() => {
    if (productShopifySettings?.marginObject) {
      setShopifyStatus(
        values.isLinkToShopify
          ? SHOPIFY_STATUS_OPTIONS[0]
          : SHOPIFY_STATUS_OPTIONS[1]
      );

      setFieldValue(
        "shopifySettingId",
        productShopifySettings?.marginObject?.id
      );
      setFieldValue(
        "isOnlineQuantity",
        productShopifySettings?.marginObject?.isOnlineQuantity
      );
      setFieldValue(
        "isOnlineUnitSellPrice",
        productShopifySettings?.marginObject?.isOnlineUnitSellPrice
      );
      setFieldValue("shopifySettingsObject", {
        ...values?.shopifySettingsObject,
        ...productShopifySettings,
      });
    }
  }, [productShopifySettings]);

  useEffect(() => {
    if (shopifySettings?.global) {
      if (values.shopifySettingId) {
        getShopifyMappingsById(currentStore.id, values.shopifySettingId);
      } else {
        const productType = getTypeOrCategoryObject(
          customTypes,
          values.productType
        )?.productType;
        const category = getTypeOrCategoryObject(
          customCategories,
          values.category_name
        )?.name;
        const subcategory = getTypeOrCategoryObject(
          customSubCategories,
          values.subcategory
        )?.name;

        let shopifyPresetObject = {};
        shopifyPresetObject = getDefaultShopifySettings(
          handleBeautifyMarketPrice(values),
          shopifySettings,
          productType,
          {
            ...values,
            tags: customProductSelectedTags,
            condition: values.condition,
            cardRarity: EMPTY_STRING,
            genre: subcategory,
            consoleName: category,
          }
        );
        const formik = formikRef.current;
        const { isLinkToShopify, isOnlineQuantity, isOnlineUnitSellPrice, id } =
          shopifyPresetObject?.marginObject || {};
        if (formik) {
          formik.setFieldValue("shopifySettingId", id);
          formik.setFieldValue("isLinkToShopify", isLinkToShopify);
          formik.setFieldValue("isOnlineQuantity", isOnlineQuantity);
          formik.setFieldValue("isOnlineUnitSellPrice", isOnlineUnitSellPrice);
        }
        setProductShopifySettings(shopifyPresetObject);
      }
    }
  }, [
    shopifySettings,
    values.subcategory,
    values.productType,
    values.category_name,
  ]);

  const setNewShopifySettingsId = (option) => {
    setFieldValue("shopifySettingId", option.shopifySettingId);
    setFieldValue("isOnlineQuantity", option.isOnlineQuantity);
    if (option.shopifySettingsObject) {
      setFieldValue("shopifySettingsObject", option.shopifySettingsObject);
    }
  };
  return (
    <Row className="m-0 w-100">
      <Col md={12} className="add-inventory-hero-wrapper my-2 py-4 px">
        <Row className="m-0">
          <Col
            md={12}
            className="mb-2 tab-heading text-muted d-flex justify-content-between align-items-center"
          >
            Product Information
            <div className="d-flex justify-content-center align-items-center gap-3">
              <CheckboxField
                name="trackQuantity"
                label="Track Quantity"
                isLabelLeft={true}
                // handleChange={(name, value) => {
                //   handleTrackQuantityChange(
                //     name,
                //     value,
                //     setFieldValue
                //   );
                // }}
              />
            </div>
          </Col>
          <Col
            md={values.trackQuantity ? 8 : 12}
            className="mb-3"
            onClick={() => {
              setIsCustomItemTab(true);
            }}
          >
            <InputTextField
              name={"product_name"}
              maxLength={100}
              label="Title"
              placeHolder="Enter Title"
              className="border"
              disabled={!isEditCustomItemModal}
            />
          </Col>
          {values.trackQuantity && (
            <>
              {isShopifyStoreConnectedForProduct &&
                values?.isOnlineQuantity && (
                  <Col md={2} className="mb-2">
                    <SelectField
                      label="Product Type"
                      options={getCustomProductSaleTypeOptionList()}
                      name="isSeparateQuantity"
                      isClearable={false}
                      onChangeValue={(option) =>
                        handleProductSaleTypeChange(option, setFieldValue)
                      }
                    />
                  </Col>
                )}
              {(!(
                isShopifyStoreConnectedForProduct && values?.isOnlineQuantity
              ) ||
                !values?.isSeparateQuantity) && (
                <Col
                  md={
                    isShopifyStoreConnectedForProduct &&
                    values?.isOnlineQuantity
                      ? 2
                      : 4
                  }
                  className="mb-3 d-flex flex-column gap-2"
                >
                  <InputNumberField
                    label="In-Store Qty"
                    name="quantity"
                    placeHolder={values.trackQuantity ? "0" : ""}
                    className="add-inventory-quantity-field"
                    isConvertToDecimal={false}
                    step={"1"}
                    {...(!isEditCustomItemModal && {
                      pattern: "-?[0-9]+",
                      min: -9999,
                    })}
                    isHandleKeyDown={true}
                    isBorder={true}
                    // disabled={!values.trackQuantity}
                  />
                  {isProductExist && (
                    <span className="ms-auto">
                      <span className="fw-bold">
                        {values?.trackQuantity
                          ? isProductExist?.price?.quantity
                          : ""}
                      </span>
                      {values?.trackQuantity
                        ? ` in stock at $`
                        : "In stock at $"}
                      <span className="fw-bold">
                        {parseToThousandSeperatorDecimalNumber(
                          isProductExist?.price?.unit_sell_price
                        )}
                      </span>
                    </span>
                  )}
                </Col>
              )}

              {isShopifyStoreConnectedForProduct &&
                values?.isOnlineQuantity &&
                values.isSeparateQuantity && (
                  <Col md={2} className="mb-3 d-flex flex-column gap-2">
                    <InputNumberField
                      label="Online Qty"
                      name="onlineQuantity"
                      placeHolder={values.trackQuantity ? "0" : ""}
                      className="add-inventory-quantity-field"
                      isConvertToDecimal={false}
                      step={"1"}
                      {...(!isEditCustomItemModal && {
                        pattern: "-?[0-9]+",
                        min: -9999,
                      })}
                      isHandleKeyDown={true}
                      isBorder={true}
                      // disabled={!values.trackQuantity}
                    />
                    {isProductExist && (
                      <span className="ms-auto">
                        <span className="fw-bold">
                          {values?.trackQuantity
                            ? isProductExist?.price?.onlineQuantity || 0
                            : ""}
                        </span>
                        {values?.trackQuantity
                          ? ` in stock at $`
                          : "In stock at $"}
                        <span className="fw-bold">
                          {parseToThousandSeperatorDecimalNumber(
                            isProductExist?.price?.OnlineUnitSellPrice || 0
                          )}
                        </span>
                      </span>
                    )}
                  </Col>
                )}
            </>
          )}
          <Col md={12} className="mb-3">
            <InputTextArea
              maxLength={1500}
              name="description"
              label="Description (Optional)"
              placeHolder="Enter Description"
              className={"border"}
              disabled={!isEditCustomItemModal}
            />
          </Col>
        </Row>
      </Col>{" "}
      {/* Show the expand tab button only if not in custom item tab */}
      {!isCustomItemTab && (
        <Col
          md={12}
          className="d-flex justify-content-center align-items-center py-2"
          onClick={() => {
            setIsCustomItemTab(true);
          }}
        >
          <button type="button" className="expand-tab-button">
            <ExpandTabIcon />
          </button>
        </Col>
      )}
      {isCustomItemTab && (
        <>
          <Col md={12} className="add-inventory-hero-wrapper my-3">
            <Row className="m-0">
              <Col md={12} className="mb-2 tab-heading text-muted">
                Product Categorization
              </Col>

              {isTradeCustomItem ? (
                <>
                  <Col md={3} className="mb-2">
                    <IconSelectField
                      label="Type"
                      options={getCustomTypesOptionList(customTypes).filter(
                        (item) => item.label !== PRODUCT_TYPES_ENUMS.ALL
                      )}
                      isClearable={false}
                      name="productType"
                      customOnChange={(option) =>
                        handleTypeChange(option, setFieldValue, values)
                      }
                      isDisabled={!isEditCustomItemModal}
                    />
                  </Col>
                  <Col md={3} className="mb-2">
                    <IconSelectField
                      label="Category"
                      options={getCustomCategoriesOptionList(
                        customCategories,
                        values.productType
                      )}
                      name="category_name"
                      customOnChange={(option) =>
                        handleCategoryChange(option, setFieldValue, values)
                      }
                      isClearable={false}
                      isDisabled={!isEditCustomItemModal}
                    />
                  </Col>
                  <Col md={3} className="mb-2">
                    <IconSelectField
                      label="Sub-Category"
                      options={getCustomSubCategoriesOptionList(
                        customSubCategories,
                        values.category_name,
                        null,
                        values.productType,
                        false,
                        customCategories,
                        customTypes
                      )}
                      isDisabled={!isEditCustomItemModal}
                      name="subcategory"
                      isClearable={false}
                      customOnChange={(option) =>
                        handleSubCategoryChange(option, setFieldValue, values)
                      }
                    />
                  </Col>
                  <Col md={3} className="mb-2">
                    <IconSelectField
                      label="Condition"
                      options={
                        getTypeOrCategoryObject(customTypes, values.productType)
                          ?.productType === PRODUCT_TYPES_ENUMS.VIDEO_GAME
                          ? [
                              ...inventoryConstants.VIDEO_GAME_CONDITION,
                              {
                                value: PRODUCT_CONDITIONS_ENUMS.USED,
                                label: PRODUCT_CONDITIONS_ENUMS.USED,
                              },
                            ]
                          : getTypeOrCategoryObject(
                              customTypes,
                              values.productType
                            )?.productType === PRODUCT_TYPES_ENUMS.TRADING_CARD
                          ? [
                              ...inventoryConstants.TRADING_CARD_CONDITION,
                              ...inventoryConstants.OTHER_CONDITION,
                            ]
                          : inventoryConstants.OTHER_CONDITION
                      }
                      placeHolder="Condition..."
                      name="condition"
                      isClearable={false}
                    />
                  </Col>
                </>
              ) : (
                <>
                  <Col md={3} className="mb-2">
                    <CustomItemProductTypeSelectField
                      setFieldValue={setFieldValue}
                      customTypes={customTypes}
                      isDisabled={!isEditCustomItemModal}
                    />
                  </Col>
                  <Col md={3} className="mb-2">
                    <CustomItemCategorySelectField
                      setFieldValue={setFieldValue}
                      customCategories={customCategories}
                      values={values}
                      isDisabled={!isEditCustomItemModal}
                    />
                  </Col>
                  <Col md={3} className="mb-2">
                    <CustomItemSubcategorySelectField
                      setFieldValue={setFieldValue}
                      values={values}
                      customTypes={customTypes}
                      customCategories={customCategories}
                      customSubCategories={customSubCategories}
                      isDisabled={!isEditCustomItemModal}
                    />
                  </Col>
                  <Col md={3} className="mb-2">
                    <CustomItemConditionSelectField
                      customTypes={customTypes}
                      values={values}
                    />
                  </Col>{" "}
                </>
              )}

              <Col md={12} className="mb-3">
                <InputTextField
                  name="upc"
                  label="UPC (Optional)"
                  placeHolder="111000294854"
                  className="border"
                />
              </Col>
            </Row>
          </Col>
          <Col
            md={isShopifyStoreConnected ? (isTradeCustomItem ? 9 : 12) : 12}
            className={`my-3 ps-0 ${isTradeCustomItem ? "" : "pe-0"}`}
          >
            <Row className="add-inventory-hero-wrapper  m-0 h-100">
              <Col md={12} className="mb-2 tab-heading text-muted">
                Product Tags
              </Col>
              <Col md={12}>
                <ProductTagList
                  productDetail={{
                    tags: [
                      ...(customProductSelectedTags?.map((tag, index) => ({
                        id: index,
                        label: tag,
                        selected: true,
                      })) || []),
                    ],
                  }}
                  className={"align-items-center"}
                  tagsList={[]}
                  suggestedArrayList={productTags}
                  onSelectTagsChange={onCustomProductSelectTagsChange}
                  customProductTags={true}
                />
              </Col>
            </Row>
          </Col>
          {!isTradeCustomItem ? (
            ""
          ) : !isShopifyStoreConnected ? (
            ""
          ) : (
            <Col md={3} className="add-inventory-hero-wrapper my-3">
              <div className="d-flex flex-column justify-content-between h-100 w-100 gap-3">
                <div className=" w-100 d-flex justify-content-between align-items-center">
                  <ShopifyLogo
                    width={150}
                    height={"auto"}
                    className="text-secondary"
                  />
                  <ProductShopifyMappingSettingModal
                    color={"text-purple"}
                    productDataObject={values}
                    productShopifySettings={productShopifySettings}
                    setProductDataObject={setNewShopifySettingsId}
                    isShowInStoreOnlineQuantityCheck={true}
                    handleStoreAndOnlineQuantityChange={
                      handleStoreAndOnlineQuantityChange
                    }
                  />
                </div>
                <ShopifySelectDropdown
                  isBlack={true}
                  options={SHOPIFY_STATUS_OPTIONS}
                  selectedValue={shopifyStatus}
                  handleChange={handleStatusChange}
                />
              </div>
            </Col>
          )}
          <Col
            md={isTradeCustomItem || !isShopifyStoreConnected ? 12 : 9}
            className={`my-3 ps-0 ${isTradeCustomItem ? "pe-0" : ""}`}
          >
            <Row className="m-0 add-inventory-hero-wrapper ps-2">
              <Col
                md={12}
                className="mb-2 tab-heading text-muted d-flex align-items-center justify-content-between"
              >
                <span>Pricing</span>
                {/* {values.isLinkToShopify && (
                  <CheckboxField
                    name={"isOnlineUnitSellPrice"}
                    label="Different Online Price"
                    isLabelLeft={true}
                  />
                )} */}
              </Col>
              {isTradeCustomItem ? (
                <>
                  <Col md={6} className="border-end pe-4 pb-3">
                    <InputNumberField
                      label="Cash Offer"
                      name="cashOffer"
                      placeHolder="0.00"
                      className="add-inventory-quantity-field w-100"
                      isBorder={true}
                      IconImage={DollarIcon}
                      handleChange={(e) =>
                        handleCashOfferValues(e, setFieldValue, ratio)
                      }
                      outerWrapperClassName="w-100"
                    />
                  </Col>{" "}
                  <Col md={6} className="mt-auto ps-4 pb-3">
                    <InputNumberField
                      label="In Store Stock Price"
                      name="inStockPrice"
                      placeHolder="0.00"
                      className="add-inventory-quantity-field"
                      isBorder={true}
                      IconImage={DollarIcon}
                    />
                  </Col>
                  <Col md={6} className="border-end pe-4 pb-3">
                    <InputNumberField
                      label="Trade Offer"
                      name="tradeOffer"
                      placeHolder="0.00"
                      className="add-inventory-quantity-field w-100"
                      isBorder={true}
                      IconImage={DollarIcon}
                      handleChange={(e) =>
                        handleTradeOfferValues(e, setFieldValue, ratio)
                      }
                      outerWrapperClassName="w-100"
                    />
                  </Col>
                  {isShopifyStoreConnectedForProduct && (
                    <Col md={6} className="ps-4 pb-3">
                      <InputNumberField
                        label="Online Stock Price"
                        name="onlineUnitSellPrice"
                        placeHolder="0.00"
                        className="add-inventory-quantity-field"
                        isBorder={true}
                        IconImage={DollarIcon}
                      />
                    </Col>
                  )}
                </>
              ) : (
                <>
                  <Col className="mb-2">
                    <InputNumberField
                      label="Cost of Goods"
                      name="costOfGoods"
                      placeHolder="0.00"
                      className="add-inventory-quantity-field"
                      isBorder={true}
                      IconImage={DollarIcon}
                    />
                  </Col>
                  <Col className="mb-2">
                    <InputNumberField
                      label="In-Store Stock Price"
                      name="inStockPrice"
                      placeHolder="0.00"
                      className="add-inventory-quantity-field"
                      isBorder={true}
                      IconImage={DollarIcon}
                    />
                  </Col>
                  {isShopifyStoreConnectedForProduct && (
                    <Col className="mb-2">
                      <InputNumberField
                        label="Online Stock Price"
                        name="onlineUnitSellPrice"
                        placeHolder="0.00"
                        className="add-inventory-quantity-field"
                        isBorder={true}
                        IconImage={DollarIcon}
                      />
                    </Col>
                  )}{" "}
                </>
              )}
            </Row>
          </Col>
          {isTradeCustomItem ? (
            ""
          ) : !isShopifyStoreConnected ? (
            ""
          ) : (
            <Col md={3} className="add-inventory-hero-wrapper my-3">
              <div className="d-flex flex-column justify-content-between h-100 w-100 gap-3">
                <div className=" w-100 d-flex justify-content-between align-items-center">
                  <ShopifyLogo
                    width={150}
                    height={"auto"}
                    className="text-secondary"
                  />
                  <ProductShopifyMappingSettingModal
                    color={"text-purple"}
                    productDataObject={values}
                    productShopifySettings={productShopifySettings}
                    setProductDataObject={setNewShopifySettingsId}
                    isShowInStoreOnlineQuantityCheck={true}
                    handleStoreAndOnlineQuantityChange={
                      handleStoreAndOnlineQuantityChange
                    }
                  />
                </div>
                <ShopifySelectDropdown
                  isBlack={true}
                  options={SHOPIFY_STATUS_OPTIONS}
                  selectedValue={shopifyStatus}
                  handleChange={handleStatusChange}
                />
              </div>
            </Col>
          )}

          <Col md={6} className="d-flex align-items-end gap-2 ms-auto">
            <Button
              label={buttonNameConstants.CANCEL}
              className="w-100"
              type="button"
              handleClick={() => handleHideModal()}
              buttonType={buttonTypeConstants.GHOST_BUTTON}
              isDisabled={isSpinnerEnabled(
                spinnerArray,
                inventoryConstants.ADD_INVENTORY
              )}
            />
            <Button
              label={
                isTradeCustomItem
                  ? isProductEdit && isEditCustomItemModal
                    ? buttonNameConstants.SAVE
                    : buttonNameConstants.ADD_TO_CART
                  : buttonNameConstants.ADD_TO_INVENTORY
              }
              className="w-100"
              type="submit"
              isDisabled={isSpinnerEnabled(
                spinnerArray,
                inventoryConstants.ADD_INVENTORY
              )}
            />
          </Col>
        </>
      )}
    </Row>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  shopify: state.shopify,
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  itemOrganization: state.itemOrganization,
  productShopifySettings: state.inventory.productShopifySettings,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  setProductShopifySettings: (data) =>
    dispatch(inventoryActions.setProductShopifySettings(data)),
  getShopifyMappingsById: (storeId, id) =>
    dispatch(shopifyActions.getShopifyMappingsById(storeId, id)),
});

//-------Export AddNewUser Component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomInventoryComponent);
